// extracted by mini-css-extract-plugin
module.exports = {"isi":"safetyInformation_isi__3URuz"};